document.addEventListener("DOMContentLoaded", function () {
    console.log("section-hero-module.js loaded")

    const $heroModule = $('section.hero-module')
    const $slides = $heroModule.find('.slides')

    const infinite = $slides.data("is-infinite")
    const autoplay = $slides.data("is-autoplay")
    const autoplaySpeed = $slides.data("autoplay-speed") * 1000

    $slides.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $heroModule.find(".slick-prev"),
        nextArrow: $heroModule.find(".slick-next"),
        adaptiveHeight: true,
        infinite,
        autoplay,
        autoplaySpeed
    })
})
